<template>
  <div class="chitolawitem">
    <div class="lawin flex_start">
      <div class="usercov">
        <img src="../../../assets/base/small_rentou.png" />
      </div>
      <div>
        <div class="lawname">张三律师</div>
        <div class="lawnenl">擅长：债权债务、损害赔偿 | 咨询解答：1234 条</div>
      </div>
      <div class="zxbtn">点击咨询</div>
    </div>
    <div class="jd flex_start">
      <div class="huidaicon">
        <img src="../../../assets/claimdet/huidaicon.png" />
      </div>
      <div class="htjdnr" ref="htjdnr" :style="{ height: righei }">
        <span>话题解答：</span>
        <div ref="nrtxtdata" v-html="txtdata"></div>
        <div class="zhankai" @click="clizk">[{{ rigbomtxt }}]</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      seleact: false,
      txtdata: `
        <p>离婚的问题，如果是协议离婚可以直接去颁发结婚证的民政局办理手续也可以去双方任意一方户
        籍所在地民政局办理。如果选择诉讼离婚，则应当参照我国《民诉意见》中有相关的规定。</p>
        <p>《民诉意见》第十二条规定</p>
        <p>夫妻一方离开住所地超过一年，另一方起诉离婚的案件，由原告住所地人民法院管辖。夫妻双方离开住所地超过一年，
        一方起诉离婚的案件，由被告经常居住地人民法院管辖;没有经常居珠珠珠珠珠珠回收从东海成佛删除和覅付费</p>
        <p>夫妻一方离开住所地超过一年，另一方起诉离婚的案件，由原告住所地人民法院管辖。夫妻双方离开住所地超过一年，
        一方起诉离婚的案件，由被告经常居住地人民法院管辖;没有经常居珠珠珠珠珠珠回收从东海成佛删除和覅付费</p>
        <p>夫妻一方离开住所地超过一年，另一方起诉离婚的案件，由原告住所地人民法院管辖。夫妻双方离开住所地超过一年，
        一方起诉离婚的案件，由被告经常居住地人民法院管辖;没有经常居珠珠珠珠珠珠回收从东海成佛删除和覅付费</p>
    `,
      brheight: 0,
    };
  },
  computed: {
    rigbomtxt() {
      return this.seleact ? "隐藏" : "展示";
    },
    righei() {
      return this.seleact ? this.brheight + "px" : "120px";
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.brheight = this.$refs.nrtxtdata.clientHeight;
    });
  },
  methods: {
    clizk() {
      this.seleact = !this.seleact;
    },
  },
};
</script>

<style lang="scss" scoped>
.chitolawitem {
  padding: 40px 0;
  position: relative;
  .lawin {
    position: relative;
    .usercov {
      margin-right: 20px;
      img {
        width: 48px;
        height: 48px;
      }
    }
    .lawname {
      font-size: 18px;
      line-height: 16px;
      color: #333333;
    }
    .lawnenl {
      font-size: 14px;
      color: #ccc;
      margin-top: 10px;
    }
    .zxbtn {
      display: none;
      cursor: pointer;
      position: absolute;
      top: 10px;
      right: 0;
      width: 86px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      background: #0465ea;
      border-radius: 14px;
      font-size: 16px;
      color: #ffffff;
    }
  }
  .jd {
    margin-top: 15px;
    padding-left: 30px;
    align-items: flex-start;
    .huidaicon {
      margin-right: 16px;
      img {
        width: 21px;
        height: 23px;
      }
    }
    .htjdnr {
      font-size: 14px;
      color: #666;
      line-height: 24px;
      overflow: hidden;
      transition: all 0.3s;
      position: relative;
      span {
        color: #999999;
        float: left;
      }
      .zhankai {
        position: absolute;
        bottom: 0;
        right: 0;
        cursor: pointer;
        color: #0465ea;
      }
    }
  }

  &:hover {
    .lawin .zxbtn {
      display: block;
    }
  }
}
</style>